<script>
import Navbar from "@/components/Navbar";


export default {
  components: {
    Navbar,
  },
  methods: {
    openCookieModal(event) {
      event.preventDefault();
      window.Osano.cm.showDrawer();
    },
    openPrivacyModal(event) {
      event.preventDefault();
      window.Osano.cm.showDoNotSell();
    }
  }
};
</script>

<template>
  <div id="app">
    <div id="content antialiased" style="position: relative">
      <Navbar />
      <div class="mx-auto w-full lg:w-3/4">
        <router-view />
        <Toast />
      </div>
    </div>
    <footer class="sm:ml-12">
      <ol>
        <li>
          <a target="_blank" :href="$t('footer.privacy.link')">
            {{ $t("footer.privacy.text") }}
          </a>
          <span class="point" aria-hidden="true">·</span>
        </li>
        <li>
          <a target="_blank" :href="$t('footer.terms.link')">
            {{ $t("footer.terms.text") }}
          </a>
          <span class="point" aria-hidden="true">·</span>
        </li>
        <li class="osano-cookie-modal">
          <a href="#cookie-modal" @click="openCookieModal">
            {{ $t("footer.cookies.text") }}
          </a>
          <span class="point osano-privacy-choice" aria-hidden="true">·</span>
        </li>
        <li class="osano-privacy-choice">
          <a href="#privacy-choice-modal" @click="openPrivacyModal">
            {{ $t("footer.privacy-choice.text") }}
          </a>
        </li>
      </ol>
    </footer>
  </div>
</template>

<style scoped>
.point {
  padding-inline: 18px;
}

footer {
  -webkit-text-size-adjust: 100%;
  font-family:
    Airbnb Cereal VF,
    Circular,
    -apple-system,
    BlinkMacSystemFont,
    Roboto,
    Helvetica Neue,
    sans-serif;
  color: #222222;
  -webkit-font-smoothing: antialiased;
  font-synthesis: none;
  line-break: strict;
  text-align: left !important;
  display: inline-block;
  letter-spacing: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;
  box-sizing: border-box;
  padding-top: 24px;
  padding-bottom: 24px;
  border-top: 1px solid #ebebeb;
  width: stretch;
  box-sizing: border-box;

  @media (min-width: 640px) {
    margin-right: 3rem;
  }
}

ol {
  display: inline;
  margin: 0;
  padding: 0;
}

li {
  display: inline-block;
}

a {
  font-size: 0.875rem;
  line-height: 1.125rem;
}

a:hover {
  text-decoration: underline;
  text-decoration-thickness: calc(0.6px * 0.05rem);
}
</style>
